import { render, staticRenderFns } from "./order-obj.vue?vue&type=template&id=616b181e&lang=pug&"
import script from "./order-obj.vue?vue&type=script&lang=js&"
export * from "./order-obj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports